const FIREBASE_STORAGE_HOSTS = new Set([
  'firebasestorage.googleapis.com',
  'storage.googleapis.com'
]);
const STORAGE_IMAGE_PROXY_PATH = '/api/storage-image';

const normalizeObjectPath = (value) => {
  let decoded = String(value || '').trim();
  for (let attempt = 0; attempt < 3; attempt += 1) {
    try {
      const next = decodeURIComponent(decoded);
      if (!next || next === decoded) break;
      decoded = next;
    } catch {
      break;
    }
  }
  return encodeURIComponent(decoded);
};

const hasApiProxyInDev = () => {
  const useRemoteProxy = String(import.meta.env.VITE_USE_REMOTE_API_PROXY || '').toLowerCase() === 'true';
  return Boolean(
    import.meta.env.VITE_LOCAL_API_URL
    || import.meta.env.VITE_API_BASE_URL
    || useRemoteProxy
  );
};
const isStorageProxyDisabledInRuntime = () =>
  typeof window !== 'undefined' && window.__stocktagDisableStorageProxy === true;

export const clearStorageProxyRuntimeOverride = () => {
  if (typeof window !== 'undefined') {
    delete window.__stocktagDisableStorageProxy;
  }
};

export const normalizeFirebaseStorageUrl = (rawSrc) => {
  const source = String(rawSrc || '').trim();
  if (!source || source.startsWith('/')) return source;

  let parsedUrl;
  try {
    parsedUrl = new URL(source);
  } catch {
    return source;
  }

  if (parsedUrl.protocol !== 'https:' || !FIREBASE_STORAGE_HOSTS.has(parsedUrl.hostname)) {
    return source;
  }

  const v0PathMatch = parsedUrl.pathname.match(/^\/v0\/b\/([^/]+)\/o\/(.+)$/);
  const downloadPathMatch = parsedUrl.pathname.match(/^\/download\/storage\/v1\/b\/([^/]+)\/o\/(.+)$/);
  const pathMatch = v0PathMatch || downloadPathMatch;
  if (!pathMatch) return source;

  const bucketName = String(pathMatch[1] || '').trim();
  const objectPath = normalizeObjectPath(pathMatch[2]);
  if (!bucketName || !objectPath) return source;

  parsedUrl.pathname = `/v0/b/${bucketName}/o/${objectPath}`;
  if (!parsedUrl.searchParams.has('alt')) {
    parsedUrl.searchParams.set('alt', 'media');
  }
  return parsedUrl.toString();
};

export const proxifyFirebaseStorageImage = (rawSrc) => {
  const source = normalizeFirebaseStorageUrl(rawSrc);
  if (!source || source.startsWith('/')) return source;

  if (isStorageProxyDisabledInRuntime()) {
    return source;
  }

  if (import.meta.env.DEV && !hasApiProxyInDev()) {
    return source;
  }

  let parsedUrl;
  try {
    parsedUrl = new URL(source);
  } catch {
    return source;
  }

  if (parsedUrl.protocol !== 'https:' || !FIREBASE_STORAGE_HOSTS.has(parsedUrl.hostname)) {
    return source;
  }

  if (!/^\/v0\/b\/[^/]+\/o\//.test(parsedUrl.pathname) && !/^\/download\/storage\/v1\/b\/[^/]+\/o\//.test(parsedUrl.pathname)) {
    return source;
  }

  return `${STORAGE_IMAGE_PROXY_PATH}?url=${encodeURIComponent(parsedUrl.toString())}`;
};
